import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const iconChipFn = /* @__PURE__ */ createRecipe('icon-chip', {
  "variant": "solid",
  "size": "md"
}, [])

const iconChipVariantMap = {
  "variant": [
    "solid",
    "outline"
  ],
  "tone": [
    "neutral",
    "primary",
    "secondary",
    "inverse",
    "warm"
  ],
  "size": [
    "sm",
    "md",
    "lg",
    "xl"
  ]
}

const iconChipVariantKeys = Object.keys(iconChipVariantMap)

export const iconChip = /* @__PURE__ */ Object.assign(memo(iconChipFn.recipeFn), {
  __recipe__: true,
  __name__: 'iconChip',
  __getCompoundVariantCss__: iconChipFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: iconChipVariantKeys,
  variantMap: iconChipVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, iconChipVariantKeys)
  },
  getVariantProps: iconChipFn.getVariantProps,
})